import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { createPrefixOfResource } from '../../common'

export const ImageComp = ({ src, ...props }) => {
    const dispatch = useDispatch()
    const webpSupportReducer = useSelector(({ webpSupportReducer }) => webpSupportReducer)

    const getImageUrl = useCallback((imgUrl) => {
        let urlParts = imgUrl.split('.')
        let extension = urlParts.pop()
        let urlWithoutExtension = urlParts.join('.')
        if (webpSupportReducer === true) {
            if (isMobile) {
                return urlWithoutExtension + '.webp'
            } else {
                if (urlWithoutExtension.includes('@2x')) {
                    return urlWithoutExtension + '.webp'
                } else {
                    return urlWithoutExtension + '@2x.webp'
                }
            }
        } else if (webpSupportReducer === false) {
            if (isMobile) {
                return imgUrl
            } else {
                if (imgUrl.includes('@2x')) {
                    return imgUrl
                } else {
                    return urlWithoutExtension + '@2x.' + extension
                }
            }
        }
        return null
    }, [webpSupportReducer, isMobile])

    useEffect(() => {
        if (webpSupportReducer === null) {
            dispatch({ type: 'CHECKING_WEBP_SUPPORT' })
        }
    }, [webpSupportReducer, dispatch])

    return (
        <img src={getImageUrl(`${createPrefixOfResource()}${src}`)} {...props} />
    )
}